<router-outlet />
@let toasterMessage = toasterService.message();
@if (toasterMessage) {
  <ds-toast
    (onClose)="closeToaster()"
    class="toast"
    [inline]="true"
    [variant]="toasterMessage.variant"
    [allowClose]="true"
    [autoHideDuration]="toasterMessage.duration"
  >
    {{ toasterMessage.message }}
  </ds-toast>
}
